import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import type { WithdrawVesuUsdcHookInputParams } from "@chipi-stack/types";

type WithdrawVesuUsdcInput = {
  params: WithdrawVesuUsdcHookInputParams;
  bearerToken: string;
};

/**
 * Hook for withdrawing USDC from Vesu protocol
 */
export function useWithdrawVesuUsdc(): {
  withdrawVesuUsdc: (params: WithdrawVesuUsdcInput) => void;
  withdrawVesuUsdcAsync: (params: WithdrawVesuUsdcInput) => Promise<string>;
  data: string | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
} {
  const { chipiSDK } = useChipiContext();

  const mutation: UseMutationResult<string, Error, WithdrawVesuUsdcInput> =
    useMutation({
      mutationFn: (params: WithdrawVesuUsdcInput) =>
        chipiSDK.withdrawVesuUsdc({
          params: {
            ...params.params,
            amount: String(params.params.amount),
          },
          bearerToken: params.bearerToken,
        }),
    });

  return {
    withdrawVesuUsdc: mutation.mutate,
    withdrawVesuUsdcAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
